module.exports = __webpack_public_path__ + "static/media/logo.3c13d7aa.svg";